// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"64":"Recap","155":"CollabActivities","318":"Collaborators","860":"createApp"}[chunkId] + "." + {"64":"ac2626f1","155":"0c40d6f3","318":"029c8ce4","860":"4b6e72c7"}[chunkId] + ".css";
};